export default __webpack_public_path__ + "static/media/up-arrow.5bb81b4f.svg";